import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const Wishlist = ({ count }) => (
  <div className='wishlist zindex-high col-auto'>
    <div className='row align-items-center h-100 justify-content-end justify-content-sm-center px-3 px-sm-0 px-md-3 mr-sm-3 mx-md-0'>
      <Link
        to='/wishlist'
        className='d-block'
        aria-label='Favoritos'
      >
        <div className='col-auto pos-relative'>
          {count > 0 && (
            <strong className='wishlist-count txt-center txt-font-body pos-absolute w-100 l-0'>
              {count}  <span className='hide-absolute'>{count === 1 ? 'item' : 'itens'} na lista de favoritos</span>
            </strong>
          )}
          <div
            className={`wishlist-status p-1`}
          >
            <i className='icon icon_wishlist' aria-hidden='true' />
          </div>
        </div>
      </Link>
    </div>
  </div>
)

Wishlist.propTypes = {
  count: PropTypes.number.isRequired
}

Wishlist.defaultProps = {
  itemCount: 0
}

export default Wishlist



// WEBPACK FOOTER //
// ./src/App/Header/Wishlist/Wishlist.js